// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__JYSU0","label":"Checkbox_label__hltEW"};